import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Controller} from "react-hook-form";
import FieldWithValidation from "../../../generic/fields/FieldWithValidation";
import {Input} from "reactstrap";
import {useDefaultEndpoints} from "../../../../lib/api/useDefaultEndpoints";
import {Loader} from "../../../generic/loader";
import {t} from "i18next";

const LegalEntity = ({form, state, setState, isRequired = true, params = {}}) => {
    const {control, errors} = form;
    const getLegalEntities = useDefaultEndpoints('legal-entities').getEntries;
    const [legalEntities, setLegalEntites] = useState([])
    useEffect(() => {
        getLegalEntities(params).then(res => setLegalEntites(() => res));
    }, [JSON.stringify(params)])

    return !legalEntities.length
        ? <Loader/>
        : (
            <Controller
                control={control}
                name="legal_entity_id"
                defaultValue={state.legal_entity_id?.id || state.legal_entity_id || ''}
                rules={isRequired ? {required: t('inputs.validation.required')} : {}}
                render={(
                    {value, onBlur, name, ref, onChange},
                    {invalid}
                ) =>
                    <FieldWithValidation invalid={invalid} errors={errors} label={t('common.forms.legalEntity.label')}
                                         name={name} isRequired={isRequired}
                    >
                        <Input type="select" id={name} invalid={invalid} name={name} onBlur={onBlur}
                               style={{border: invalid ? '1px solid #dc3545' : '0'}}
                               value={value}
                               onChange={(e) => {
                                   setState(e);
                                   onChange(e.target.value)
                               }}>
                            <option value={''}>{t('common.forms.legalEntity.pickLegalEntity')}</option>
                            {legalEntities.map(legalEntity => <option key={legalEntity.id}
                                                                      value={legalEntity.id}>{legalEntity.name}</option>)}
                        </Input>
                    </FieldWithValidation>
                }
            />
        );
}

LegalEntity.propTypes = {
    form: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    setState: PropTypes.func.isRequired,
    isRequired: PropTypes.bool,
};
export default LegalEntity;